export default __webpack_public_path__ + "static/design-99c2340ef6385eef620e8041df2cc7c2.jpg";